import { render, staticRenderFns } from "./RelocationOtherTerms.vue?vue&type=template&id=89e14a48&scoped=true"
import script from "./RelocationOtherTerms.vue?vue&type=script&lang=js"
export * from "./RelocationOtherTerms.vue?vue&type=script&lang=js"
import style0 from "./RelocationOtherTerms.vue?vue&type=style&index=0&id=89e14a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e14a48",
  null
  
)

export default component.exports